module.exports = __webpack_public_path__ + "img/4_137.6f36926f.png";